exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".page-consultancy-and-research{overflow:hidden}.page-consultancy-and-research .main-text{color:#363636;background-color:#eee;font-size:17px;font-weight:500;padding-top:60px;padding-bottom:60px;width:100%;text-align:center}.page-consultancy-and-research .main-text>p{max-width:1024px;margin:0 auto}.page-consultancy-and-research .main-text>p:first-child{margin-bottom:20px}@media (max-width:768px){.page-consultancy-and-research .main-text{padding-left:35px;padding-right:35px}.page-consultancy-and-research .page-consultancy-main-banner{height:240px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/features/PageConsultancyAndResearch/PageConsultancyAndResearch.scss
// module id = 1099
// module chunks = 0